<template>
  <div>
      <graph v-if="graph" :payload="graph" @click-edit-button="clickEditButton" @click-delete-button="clickDeleteButton"/>
  </div>
</template>

<script>
import Graph from '@/components/parts/Graph.vue';

export default {
  components: {
    'graph' : Graph
  },
  props: {
    graph: {
      required: true
    }
  },
  methods: {
    clickEditButton(arg0) {
      this.$emit('click-edit-button', arg0);
    },
    clickDeleteButton(arg0) {
      this.$emit('click-delete-button', arg0);
    }
  }
}
</script>